import { render, staticRenderFns } from "./ScopeLibraryTagBar.vue?vue&type=template&id=7eda00dd&scoped=true&"
import script from "./ScopeLibraryTagBar.vue?vue&type=script&lang=ts&"
export * from "./ScopeLibraryTagBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eda00dd",
  null
  
)

export default component.exports